import { MEMBERS_DEFAULT } from "types/actions/members"

export const setMembers = data => ({
  type: MEMBERS_DEFAULT,
  data
})



// WEBPACK FOOTER //
// ./src/actions/members.js